import styled from "styled-components";
import { InputStyleProps, InputMixin } from "../SharedInputComponent";
import { AuthoryColorSchemeProps, isContrastWithDarkHigher, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";
import { hexToRgba } from "../../utils/hexToRGBA";
import { SVGThemableHover, SVGThemableStyle } from "../ReusableStyledComponents/ActiveFilterToggle";

const V3ThemableSel = styled.select<{ $allowUserThemable: boolean } & AuthoryColorSchemeProps & InputStyleProps>`
    ${InputMixin};
    color: ${({ theme }) => theme.v3.colors.grey48};

    ${({ $allowUserThemable }) => $allowUserThemable && UserThemableHeading}

    opacity: ${({ $allowUserThemable, theme }) => {
        if(!$allowUserThemable) return 1;
        return isContrastWithDarkHigher(theme.customization.backgroundColor) ? 1 : 0.6;
    }};

    background-color: ${({ theme, $allowUserThemable }) =>{
        if(!$allowUserThemable) return theme.v3.colors.grey96;
        return hexToRgba(theme.customization.backgroundColor, 1);
    }};

    border: ${({ theme, $allowUserThemable }) => {
        if(!$allowUserThemable) return;
        return `1px solid ${isContrastWithDarkHigher(theme.customization.backgroundColor) ? theme.v3.colors.grey88 : theme.v3.colors.grey88}`;
    }};

    &:hover {
        cursor: pointer;
    }

    &:focus {
        border: ${({ theme, $allowUserThemable }) => {
            if(!$allowUserThemable) return;
            return `1px solid ${isContrastWithDarkHigher(theme.customization.backgroundColor) ? theme.v3.colors.grey88 : theme.v3.colors.grey88}`;
        }};
        box-shadow: none;
    }
`;

export const V3Sel = styled(V3ThemableSel)`
    appearance: none;
    padding-right: ${({ $hasError }) => $hasError ? "66px" : "38px"};
    font-size: 13px;
`;

export const SelChevPos = styled.div<{ $allowUserThemable: boolean } & AuthoryColorSchemeProps>`
    position: absolute;
    top: 13px;
    right: 18px;
    pointer-events: none;

    ${({ $allowUserThemable }) => $allowUserThemable && SVGThemableStyle}
    ${({ $allowUserThemable }) => $allowUserThemable && SVGThemableHover}
`;